import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Snackbar,
  Stack,
} from "@mui/material";
import Alert from "@mui/material/Alert";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { ErrorData } from "models/Errors/ErrorResponse";
import { JSX } from "react";
import CloseIcon from "@mui/icons-material/Close";
import "./ErrorComponent.scss";
import React from "react";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { createPortal } from "react-dom";
import {
  WAREHOUSE_PLAN_ID,
} from "components/WarehouseElements/Grid/WarehouseGrid/WarehouseGrid";

type Props = {
  errorData: ErrorData;
  status: number;
};

export const ERROR_SNACKBAR_DURATION_MS = 20000;

export function ErrorComponent({ errorData, status }: Props): JSX.Element {
  const [open, setOpen] = React.useState(status !== null);

  const handleClose = () => {
    setOpen(false);
  };

  if (status.toString()["0"] === "4") {
    return (
      <Dialog
        open={open}
        className="dialog-window"
        id="error-dialog"
        maxWidth={false}
        slotProps={{
          paper: {
            sx: {
              minWidth: "600px",
              minHeight: "250px",
            },
          },
        }}
        onClick={e => e.stopPropagation()}>
        <DialogTitle id="error-title">
          {"La requête à échouée"}
          <IconButton
            id="dialog-close-btn"
            aria-label="close"
            onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          dividers
          className="dialog-body error-body"
          style={{
            padding: "45px",
            borderStyle: "hidden",
          }}>
          <ErrorOutlineIcon
            className="error-icon"
            fontSize="large"
            sx={{ fontSize: 60 }}
          />
          <Stack>{`${errorData.detail} (${errorData.code})`}</Stack>
          <div className="error-request-id">{errorData.requestId}</div>
        </DialogContent>
        <DialogActions style={{ justifyContent: "center" }}>
          <Button
            autoFocus
            className="dialog-buttons"
            style={{
              backgroundColor: "#1976d2",
              color: "white",
              width: "35%",
            }}
            onClick={handleClose}>
            {"Ok"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  } else {
    return createPortal(
      <Snackbar
        open={true}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        autoHideDuration={ERROR_SNACKBAR_DURATION_MS}
        className="error-component-snackbar">
        <Alert severity="error" variant="filled" className="error-alert">
          {`Problème interne, veuillez communiquer avec le département TI. (${errorData.requestId})`}
        </Alert>
      </Snackbar>,
      document.getElementById(WAREHOUSE_PLAN_ID)
        ? document.getElementById(WAREHOUSE_PLAN_ID)!
        : document.body
    );
  }
}

type SnackBarProps = {
  errorMessage: string;
};

export function ErrorSnackBar({ errorMessage }: SnackBarProps): JSX.Element {
  return createPortal(
    <Snackbar
      open={true}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      autoHideDuration={ERROR_SNACKBAR_DURATION_MS}>
      <Alert severity="error" variant="filled" className="error-component">
        {errorMessage}
      </Alert>
    </Snackbar>,
    document.getElementById(WAREHOUSE_PLAN_ID)
      ? document.getElementById(WAREHOUSE_PLAN_ID)!
      : document.body
  );
}

export function createErrorComponent(
  error?: FetchBaseQueryError,
  message?: string
) {
  if (error) {
    const errorStatus = error.status as number;
    let errorData: ErrorData;
    if (error.data) {
      errorData = error.data as ErrorData;
      return <ErrorComponent errorData={errorData} status={errorStatus} />;
    }
    if (message) {
      <ErrorSnackBar errorMessage={message} />;
    }
    return <ErrorSnackBar errorMessage={errorStatus + ": Erreur inattendue"} />;
  }
  if (message) {
    return <ErrorSnackBar errorMessage={message} />;
  }
  return <ErrorSnackBar errorMessage={"Erreur inattendue"} />;
}
